import { __rest } from 'tslib';
import React from 'react';
import StringMask from 'string-mask';
import { PeekInput } from './PeekInput.js';

const PeekPhoneInput = (_a) => {
    var { mask = "000-000-0000", field } = _a, props = __rest(_a, ["mask", "field"]);
    const formatter = new StringMask(mask);
    const onChange = (event) => {
        var _a, _b;
        const numbers = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value.match(/\d/g);
        const formattedValue = (numbers && formatter.apply(numbers.join(""))) || "";
        field.onChange({
            target: { name: field.name, value: (formattedValue.slice(-1) === "-" && ((_b = event.target) === null || _b === void 0 ? void 0 : _b.value)) || formattedValue },
        });
    };
    return React.createElement(PeekInput, Object.assign({}, props, { field: Object.assign(Object.assign({}, field), { onChange }) }));
};

export { PeekPhoneInput, PeekPhoneInput as default };
